/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { GraphQLList as List } from 'graphql';
import fetch from '../../core/fetch';
import PageType from '../types/PageType';

const url = 'http://agenceprolifik.ca/dev/wp-json/wp/v2/pages/160/';

let item;

const approche = {
    type: PageType,
    resolve() {
        
        return fetch(url)
        .then(res => {
            
            return res.json();
           
        })
        .then(data => {
           
            item = data;
            return item;

        });
    },
};

export default approche;



// WEBPACK FOOTER //
// ./data/queries/approche.js